import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import type { PropType } from 'vue';
import ChatRichTextEditor from '@/shared/components/ChatRichTextEditor.vue';
import type ActivityFormConfiguration from '@/models/interfaces/ActivityFormConfiguration';
import type { AutomaticEventSelectOption } from '@/modules/CMS/interfaces/AutomaticEventSelectOption';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityForm',
  props: {
    activity: {
        default: null as ActivityFormConfiguration | null,
    },
    activityTypes: {
        type: Array as PropType<AutomaticEventSelectOption[]>,
        default: () => [],
    },
    activeUsers: {
        type: Array as PropType<AutomaticEventSelectOption[]>,
        default: () => [],
    },
},
  emits: ["change"],
  setup(__props, { emit }: { emit: ({
    (event: 'change', payload: ActivityFormConfiguration): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const localActivityType = ref('');
const localName = ref('');
const localResponsiblePersonType = ref('');
const localNote = ref('');

function onActivityChange(activity: ActivityFormConfiguration | null) {
    if (activity) {
        localActivityType.value = activity.activityType ?? '';
        localName.value = activity.name ?? '';
        localResponsiblePersonType.value = activity.responsiblePersonType ?? '';
        localNote.value = activity.note ?? '';
    } else {
        localActivityType.value = '';
        localName.value = '';
        localResponsiblePersonType.value = '';
        localNote.value = '';
    }
}

function onUpdateContent(content: string) {
    localNote.value = content;
    onInput();
}

function onInput() {
    emit('change', {
        activityType: localActivityType.value,
        name: localName.value,
        responsiblePersonType: localResponsiblePersonType.value,
        note: localNote.value,
    });
}

watch(() => props.activity, onActivityChange, { immediate: true });

return { __sfc: true,props, emit, localActivityType, localName, localResponsiblePersonType, localNote, onActivityChange, onUpdateContent, onInput, ChatRichTextEditor }
}

})